export default __webpack_public_path__ + "static/media/1.c3eb0448.webp";